import React, { useEffect, useState, useRef } from 'react';
import SvgIcon from "./../svg/svg"

const Slider = ({
  imageNumber,
  handleSliderChange,
  lastFrameNumber,
  startTotalMinutes,
  timeStep,
  selectedDate,
  selectedView,
  totalMinutes,
  sunrise,
  altitude,
  date,
  sunset,
  hourString,
  previousFirstFrameNumber,
  previousImageNumber,
}) => {
  const [autoplay, setAutoplay] = useState(false);
  const [autoplayInterval, setAutoplayInterval] = useState(null);
  const [currentHour, setCurrentHour] = useState('');
  const wrapperRef = useRef(null);
  const [relativeHour, setRelativeHour] = useState(0);

  // Gestion de la position du slider
  const sliderPosition = lastFrameNumber !== null ? (window.innerWidth > 992 ? ((imageNumber / lastFrameNumber) * 58.75) : ((imageNumber / lastFrameNumber) * 46.5)) : 0;

  // Gestion de l'affichage de l'heure
  useEffect(() => {
    setCurrentHour(hourString);
    // Calcul du numéro d'image à afficher
    const calculatedImage = Math.abs(10 * previousImageNumber + (previousFirstFrameNumber - startTotalMinutes)) / timeStep;
    setRelativeHour(calculatedImage);
  }, [selectedDate, selectedView, imageNumber, lastFrameNumber, startTotalMinutes, timeStep, previousFirstFrameNumber, previousImageNumber, hourString]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!wrapperRef.current.contains(event.target)) {
        // Fermer immédiatement l'autoplay
        setAutoplay(false);
        clearInterval(autoplayInterval);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchmove', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchmove', handleClickOutside);
    };
  }, [autoplayInterval]);

  // Gestion de l'autoplay
  const readHeliodon = () => {
    if (!autoplay) {
      // On lance l'autoplay
      setAutoplay(true);

      // On calcule le nombre d'images restantes
      let nextImageNumber = imageNumber + 1;
      // On définit l'intervalle
      const interval = setInterval(() => {
        // On vérifie qu'il reste des images à afficher
        if (nextImageNumber <= lastFrameNumber) {
          handleSliderChange({ target: { value: nextImageNumber } });
          // On incrémente le nombre d'images
          nextImageNumber += 1;
        } else {
          // On arrête l'autoplay
          setAutoplay(false);
          handleSliderChange({ target: { value: 0 } });

          // On arrête l'intervalle
          clearInterval(interval);
        }
      }, 400);
      // On stocke l'intervalle
      setAutoplayInterval(interval);
    } else {
      // On arrête l'autoplay
      setAutoplay(false);

      // On arrête l'intervalle stocké
      clearInterval(autoplayInterval);
    }
  };


  return (
    <>

      <div className='sliderAutoplay'>
        <div
          className='sliderPlayerButton'
          type='button'
          onClick={readHeliodon}
          ref={wrapperRef}
        >
          {autoplay ? (
            <SvgIcon icon="picto-pause" />
          ) : (
            <SvgIcon icon="picto-play" />
          )}
        </div>
      </div>

      <div className='sliderMainContainer'>

        <div className='sliderContainerTest'>
          <div className='sliderIcons'>
            <div className='horizontalLine'></div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-moon" />
            </div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-sun" />
            </div>
            <div className='sliderIcon'>
              <SvgIcon icon="picto-moon" />
            </div>
          </div>
          <div className="sliderContainer">
            <div className='sliderProgress'>
              <input
                type="range"
                min={0}
                max={lastFrameNumber}
                onChange={handleSliderChange}
                step={1}
                value={imageNumber}
              />
              <div className="imageNumber" style={{ left: `${sliderPosition}vw` }}>
                {currentHour}
              </div>
            </div>
          </div>
          <div className='sliderLabels'>
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {sunrise &&
                <div>Lever du soleil : {sunrise}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-sun" /> {sunrise}
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {altitude &&
                <div>Altitude : {altitude}m</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-altitude" /> {altitude}m
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {date &&
                <div>Date : {date}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-calendar" /> {date}
              </div>
            )}
            {window.innerWidth > 992 ? (
              <div className='sliderLabel'> {sunset &&
                <div>Coucher du soleil : {sunset}</div>
              }
              </div>
            ) : (
              <div className='sliderLabel'>
                <SvgIcon icon="picto-moon" /> {sunset}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Slider;